<div class="menu-container monster-add">
  <div
    class="line filter-monster-menu"
    [ngClass]="{
      fh: settingsManager.settings.theme === 'fh',
      modern: settingsManager.settings.theme === 'modern',
      'all-editions': gameManager.game.edition
    }"
  >
    <input [(ngModel)]="filter" type="text" [ghs-label]="'monster.filter'" [ghs-label-attribute]="'placeholder'" />
    @if (gameManager.game.edition) {
      <label>
        <input tabclick type="checkbox" [checked]="allEditions" (change)="allEditions = !allEditions" />
        <span [ghs-label]="'character.filter.allEditions'"></span>
      </label>
    }
    <label [ngClass]="{ disabled: !hasBossMonster() }">
      <input
        tabclick
        type="checkbox"
        [checked]="settingsManager.settings.showBossMonster"
        (change)="settingsManager.toggle('showBossMonster')"
      />
      <span [ghs-label]="'monster.showBoss'"></span>
    </label>
    <label [ngClass]="{ disabled: !hasHiddenMonster() }">
      <input
        tabclick
        type="checkbox"
        [checked]="settingsManager.settings.showHiddenMonster"
        (change)="settingsManager.toggle('showHiddenMonster')"
      />
      <span [ghs-label]="'monster.showHidden'"></span>
    </label>
  </div>
  <div class="columns">
    @for (edition of allEditions ? gameManager.editions(true, true) : gameManager.relevantEditions(); track edition) {
      @if (monsterData(edition, filter).length > 0) {
        <div class="column spoilers bosses">
          <div
            class="line title sticky"
            [ngClass]="{
              'hide-title': !allEditions && gameManager.relevantEditions().length === 1,
              fh: settingsManager.settings.theme === 'fh',
              modern: settingsManager.settings.theme === 'modern'
            }"
          >
            <label><span [ghs-label]="'data.edition.' + edition"></span></label>
          </div>
          @for (monsterData of monsterData(edition, filter) | trackUUID; track monsterData._trackUUID) {
            <div
              class="line"
              [ngClass]="{
                disabled: hasMonster(monsterData),
                spoiler: monsterData.spoiler,
                boss: monsterData.boss,
                'hidden-monster': monsterData.hidden
              }"
            >
              @if (isSpoiled(monsterData)) {
                <a tabclick (click)="addMonster(monsterData)">
                  @if (monsterData.boss) {
                    <span class="boss-icon"><img src="./assets/images/monster/enemy.png" /></span>
                  }
                  <span [ghs-label]="'data.monster.' + monsterData.name"></span>
                  @if (monsterData.hidden) {
                    <img class="ghs-svg hidden-icon" src="./assets/images/hidden.svg" />
                  }
                </a>
              }
              @if (!isSpoiled(monsterData)) {
                <a tabclick (click)="settingsManager.addSpoiler(monsterData.name)">
                  <span class="name"><span [ghs-label]="'spoiler.placeholder'"></span></span>
                  <span class="add"><span [ghs-label]="'spoiler.add'"></span></span>
                </a>
              }
            </div>
          }
        </div>
      }
    }
    @if (filter && noResults()) {
      <div class="column">
        <div class="line">
          <label><span [ghs-label]="'monster.filter.noResult'"></span></label>
        </div>
      </div>
    }
  </div>
  @if (hasSpoilers(monsterData())) {
    <div class="line">
      <a tabclick (click)="settingsManager.addSpoilers(notSpoiled(monsterData()))"><span [ghs-label]="'spoiler.all'"></span></a>
    </div>
  }
</div>
